<template>
  <div class="massaction-confirm-modal">
    <div class="confirm-modal-title">{{ $t('inviteToDashboardMassAction.userInvitedToDashboard')}}</div>
    <div class="confirm-modal-body" v-html="$t('inviteToDashboardMassAction.usersInvitedToDashboard')" />
    <hr class="confirm-modal-divider" />
    <div class="button-container">
      <button @click="redirectToDashboard" class="confirm-modal-btn">
        {{ $t('common.okay') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectToDashboard() {
      window.location.href = "/users";
      this.$bvModal.hide("redirectModal");
    },
  },
};
</script>

<style lang="scss">
div#redirectModal___BV_modal_content_ {
  background: #ffffff;
  border-radius: 26px;
  width: 579px;
  margin-top: 200px;
  .massaction-confirm-modal {
    .confirm-modal-title {
      font-size: 17px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: start;
    }
    .confirm-modal-body {
      color: #787878;

      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: center;
      margin: 40px 0;
    }
    .button-container {
      width: 470px;
      display: flex;
      align-items: center;
      justify-content: center;
      .confirm-modal-btn {
        background-color: #103f5e;
        color: #ffffff;

        font-size: 16px;
        font-weight: 400;
        line-height: 19px;
        letter-spacing: 0em;
        border: 0;
        border-radius: 24px;
        width: 112px !important;
        height: 33px !important;
        margin-top: 20px;
        // margin-inline-start: 145px;
      }
    }

    .confirm-modal-divider {
      margin: 0;
    }
  }
}
</style>
